import { Link } from "react-router-dom";
import Navbar from '../Navbar/navbar';

import '../../../bootstrap.min.css';

const HeroStatic = ({ title }) => {

    if (!title)
        title = 'UTI Neonatal';

    return (
        // < !--Navbar & Hero Start-- >
        <div className="container-fluid position-relative p-0">
            <Navbar />
            <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                    <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">{title}</h3>
                    <ol className="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item"><Link to="/index">Início</Link></li>
                        <li className="breadcrumb-item active text-primary">{title}</li>
                    </ol>
                </div>
            </div>
        </div>
        // < !--Navbar & Hero End-- >
    );
}
export default HeroStatic;